import { Injectable } from '@angular/core';
import { FacadeService } from './facade.service';
import { ILoginState } from '../store/login/login';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  private _loginData?: ILoginState;

  constructor(private facade: FacadeService) {
    facade.login.selectLoginData$.subscribe(
      (loginData: ILoginState | undefined) => {
        this._loginData = loginData;
      }
    );
  }

  get loginData() {
    return this._loginData;
  }
}
